<template>
    <router-link :to="{ name: routeName, params: routeParams }" :title="text.view + ' ' + linkName">{{text.view}}</router-link>
</template>

<script>
    import lang from "@/shared/lang";

    export default {
        name: "ViewAction",
        props: {
            routeName: {
                type: String
            },
            routeParams: {
                type: Object
            },
            linkName: {
                type: String
            }
        },
        computed: {
            text() {
                return lang;
            },
        },
    }
</script>